<template>
  <div
    class="c-scroller"
    :style="style"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'CScroller',
  props: {
    vertical: {
      type: Boolean,
      default: false,
    },
    horizontal: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    style() {
      return {
        flexGrow: '1',
        minHeight: '0px',
        transform: 'translateZ(0px)',
        zIndex: '1',
        overflow: 'hidden auto',
        marginRight: '0px',
        marginBottom: '0px',
      };
    },
  },
};
</script>

<style
    scoped
    lang="scss"
    type="text/scss"
>

</style>
